import Ajax from '../js/common/ajax';

export default {
  // 现金流项目
  items: {
    list() {
      return Ajax.get('/cash-flow/items');
    }
  },

  // 现金等价物科目
  cashSubjects: {
    list() {
      return Ajax.get('/cash-flow/cash-subjects');
    },
    update(subjectIds) {
      return Ajax.put('/cash-flow/cash-subjects', { subjectIds });
    }
  },

  // 自动分类规则
  mappings: {
    list() {
      return Ajax.get('/cash-flow/mappings');
    },
    get(id) {
      return Ajax.get(`/cash-flow/mappings/${id}`);
    },
    save(mapping) {
      return Ajax.post('/cash-flow/mappings', mapping);
    },
    update(mapping) {
      return Ajax.put('/cash-flow/mappings', mapping);
    },
    delete(id) {
      return Ajax.delete(`/cash-flow/mappings/${id}`);
    }
  },

  // 待确认记录
  pending: {
    list(params) {
      return Ajax.get('/cash-flow/pending', params);
    },
    ignore(allocationId) {
      return Ajax.put(`/cash-flow/pending/ignore/${allocationId}`);
    }
  },

  // 凭证现金流分配
  voucher: {
    get(voucherId) {
      return Ajax.get(`/cash-flow/voucher/${voucherId}`);
    },
    confirm(allocationId, cashFlowItemCode, saveAsRule) {
      return Ajax.put('/cash-flow/voucher/confirm', {
        allocationId,
        cashFlowItemCode,
        saveAsRule
      });
    },
    confirmBatch(voucherId, cashFlowItemCode, saveAsRule) {
      return Ajax.put('/cash-flow/voucher/confirm-batch', {
        voucherId,
        cashFlowItemCode,
        saveAsRule
      });
    },
    split(allocationId, splitItems, saveAsRule) {
      return Ajax.put('/cash-flow/voucher/split', {
        allocationId,
        splitItems,
        saveAsRule
      });
    }
  },

  // 重算
  recalculate(voucherYear, voucherMonth) {
    return Ajax.post('/cash-flow/recalculate', null, {
      params: { voucherYear, voucherMonth }
    });
  },

  // 勾稽查询
  reconcile(accountDate) {
    return Ajax.get('/cash-flow/reconcile', { accountDate });
  }
};
